import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  auditActions,
  getSubscribedBlueprint,
  getModelDetails,
} from "../../store";
import {
  DataGridView,
  Button,
  Row,
  Col,
} from "@neumetric/blueprint-lib/components";
import { useNavigate } from "react-router-dom";

export const BlueprintTrackerScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const subscribedBlueprintList = useSelector(getSubscribedBlueprint);
  const modelDetails = useSelector(getModelDetails);
  const [selectedModelId, setSelectedModelId] = React.useState(null);

  React.useEffect(() => {
    dispatch(auditActions.fetchSubscribedBlueprints());
  }, [dispatch]);

  const handleNewAuditClick = React.useCallback(() => {
    navigate("/A/T/new");
  }, [navigate]);

  const handleShowBlueprintDetails = (record) => {
    const id = record?.id;
    if (!id) return;
    setSelectedModelId(id);
    dispatch(auditActions.fetchModelDetails({ id }));
  };

  const handleBackToList = () => {
    setSelectedModelId(null);
    navigate("/A/B");
  };

  const showDetails =
    Boolean(selectedModelId) &&
    Boolean(modelDetails?.id) &&
    modelDetails.id === selectedModelId;

  // ---- DETAILS VIEW ----
  if (showDetails) {
    const details = modelDetails;

    return (
      <div className="w-100 h-100 mt-20 ml-30">
        <Row
          className="text-action fs-14 mb-15 pr-10"
          justify="start"
          onClick={handleBackToList}
          style={{ cursor: "pointer" }}
        >
          Tracker
        </Row>
        <Button icon="ADD" label="New Audit" onClick={handleNewAuditClick} />

        <div className="w-100 mt-30 pl-20">
          <Row
            className="w-60"
            align="baseline"
            justify="between"
            style={{ gap: 20 }}
          >
            <div
              style={{
                display: "flex",
                gap: 12,
                minWidth: 0,
                alignItems: "baseline",
              }}
            >
              <span
                className="ff-exo2 fs-16 text-filled"
                style={{ minWidth: 95 }}
              >
                Title:
              </span>
              <span
                className="ff-exo2 fs-16 fw-600 text-filled"
                style={{ overflow: "hidden", textOverflow: "ellipsis" }}
              >
                {details?.title ?? ""}
              </span>
            </div>

            <span className="ff-exo2 fs-18 fw-600 text-filled">
              Controls: {details?.controls ?? ""}
            </span>
          </Row>

          <Row className="mt-35 w-100 gap-20" align="start" justify="start">
            <div className="w-60">
              <div
                style={{ display: "flex", gap: 12, alignItems: "flex-start" }}
              >
                <span
                  className="ff-exo2 fs-16 text-filled"
                  style={{ minWidth: 95 }}
                >
                  Description:
                </span>
                <div
                  className="ff-exo2 fs-16 fw-400 text-filled"
                  style={{
                    lineHeight: "22px",
                    maxWidth: 900,
                    whiteSpace: "pre-line",
                  }}
                >
                  {details?.desc ?? ""}
                </div>
              </div>
            </div>

            <Col
              className="w-20"
              style={{
                width: 440,
                height: 276,
                backgroundColor: "#f3f5f7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {Boolean(details?.icon || details?.icone) ? (
                <img
                  src={details?.icon || details?.icone}
                  alt={details?.icon_file_name || "Blueprint icon"}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <span className="ff-exo2 fs-12 text-placeholder">No image</span>
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  // ---- TRACKER VIEW ----
  return (
    <div className="w-100 h-100 mt-20 ml-30">
      <div className="ff-exo2 fs-20 fw-600 text-heading">
        Available Audit Blueprint
      </div>

      <Row className="w-55 h-100 mb-10 pr-10 mt-20">
        <DataGridView
          columns={BlueprintColumns}
          dataSource={subscribedBlueprintList?.rows || []}
          rowKey="id" // ✅ FIX
          EmptyComponent={<div>There are no Blueprints available.</div>}
          getCellSemantics={(column, record) => {
            if (column.dataIndex === "action") {
              return { onLinkClick: () => handleShowBlueprintDetails(record) };
            }
            return {};
          }}
        />
      </Row>
    </div>
  );
};
export const BlueprintColumns = [
  {
    title: "Blueprint ID",
    dataIndex: "blueprint_id",
    typeRepresentation: "TEXT",
    width: "20%",
  },
  {
    title: "Status",
    dataIndex: "status",
    typeRepresentation: "TEXT",
    width: "15%",
    classes: { content: "text-caps" },
  },
  {
    title: "Title",
    dataIndex: "title",
    typeRepresentation: "TEXT",
    width: "65%",
  },
  {
    title: "Action",
    dataIndex: "action",
    typeRepresentation: "LINK",
    width: "10%",
  },
];
